import React, { useState } from 'react'
import './Nav.css'
import Logo from '../../assets/logo.png'

const Nav = () => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(!clicked);
  };

  return (
    <nav>
      <a href='./#' className='logo'><img src={Logo} alt="" loading='lazy' /></a>

      <div className="menu-icons" onClick={handleClick}>
        <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
      </div>

      <ul className={clicked ? "nav-menu active" : "nav-menu"}>

        <li><a href='./#' >Home</a></li>
        <li><a  href='./#about'>About</a></li>
        <li><a href='./#services'>Services</a></li>
        <li><a href='./#projects'>Projects</a></li>
        <li><a href='./#team'>Our Team</a></li>
        <li><a href='./#contact'>Contact Us</a></li>
        <li><a href='./#services' className='order-btn' >Order Now</a></li>

      </ul>
    </nav>
  )
}

export default Nav;